import { render, staticRenderFns } from "./BindModal.vue?vue&type=template&id=3f281308&scoped=true"
import script from "./BindModal.vue?vue&type=script&lang=js"
export * from "./BindModal.vue?vue&type=script&lang=js"
import style0 from "./BindModal.vue?vue&type=style&index=0&id=3f281308&prod&lang=stylus&scoped=true"
import style1 from "./BindModal.vue?vue&type=style&index=1&id=3f281308&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f281308",
  null
  
)

export default component.exports